import SharedFormInput from '../shared/FormInput';

import {
  addMissingMandatoryField,
  removeMissingMandatoryField,
} from 'reducers/commercialFormReducer';

import type { MessageProps } from '../shared/Message/Message.types';

interface CommercialFormInputProps {
  section: number;
  name: string;
  label?: string;
  type?: string;
  step?: string | number;
  helpText?: string;
  value?: any;
  onChange?: (event: any) => void;
  message?: Omit<MessageProps, 'section'> & { section?: number };
  required?: boolean;
  subLabel?: string;
  infoText?: string;
  disabled?: boolean;
}

const noop = () => ({ type: 'commercialForm/noop' });

const CommercialFormInput = (props: CommercialFormInputProps) => {
  const formActions = {
    addMissingMandatoryField,
    removeMissingMandatoryField,
    addRemark: noop,
    removeRemark: noop,
    updateRemark: noop,
    addFile: noop,
    removeFile: noop,
  };

  return (
    <SharedFormInput
      {...props}
      formStateKey="commercialForm"
      formActions={formActions}
    />
  );
};

export default CommercialFormInput;
